export default "__VITE_ASSET__L1QDGxu3__"